import { useReducer, useCallback } from 'react';
import { M as MobileMode } from './MobileMode-DHJ6VHqt.js';
import { M as MobileModeChangeSource } from './MobileModeChangeSource-CL9HhYGS.js';

/*
 The useDefaultStateManager() sets the default logic to picking a mobile or not-mobile user
 experience.

 There are three possible sources of truth for device-specific UX:

 1. Manually set user UX preference (Highest priority)
 2. Client-side media queries
 3. Server-side device detection (Lowest priority)
 */

let Actions = /*#__PURE__*/function (Actions) {
  Actions["BROWSER_IS_MOBILE"] = "BROWSER_IS_MOBILE";
  Actions["USER_IS_MOBILE"] = "USER_IS_MOBILE";
  return Actions;
}({});
function getFirstActiveMode(modeOptions) {
  return modeOptions.reduce((acc, value) => {
    if (acc !== undefined) {
      return acc;
    }
    if (value === MobileMode.Enable) {
      return true;
    }
    if (value === MobileMode.Disable) {
      return false;
    }
    return acc;
  }, undefined);
}
function reducer(state, {
  type,
  payload
}) {
  switch (type) {
    case Actions.USER_IS_MOBILE:
      return {
        ...state,
        userIsMobile: payload,
        isMobile: getFirstActiveMode([payload, state.browserIsMobile])
      };
    case Actions.BROWSER_IS_MOBILE:
      return {
        ...state,
        browserIsMobile: payload,
        isMobile: getFirstActiveMode([state.userIsMobile, payload])
      };
  }
  return state;
}
function useDefaultStateManager(initialIsMobile = false) {
  const initialState = {
    userIsMobile: MobileMode.Auto,
    browserIsMobile: MobileMode.Auto,
    isMobile: undefined
  };
  const [{
    isMobile
  }, dispatch] = useReducer(reducer, initialState);
  const onMobileModeChange = useCallback(event => {
    if (event.source === MobileModeChangeSource.Browser) {
      dispatch({
        type: Actions.BROWSER_IS_MOBILE,
        payload: event.mobileMode
      });
    }
    if (event.source === MobileModeChangeSource.User) {
      dispatch({
        type: Actions.USER_IS_MOBILE,
        payload: event.mobileMode
      });
    }
  }, [dispatch]);
  return {
    isMobile: isMobile !== null && isMobile !== void 0 ? isMobile : initialIsMobile,
    onMobileModeChange
  };
}

export { useDefaultStateManager as u };
//# sourceMappingURL=useDefaultStateManager-PmeX2qPE.js.map
